export const CHECKOUT_URL = 'https://protocolo-anti-inflacion.impultienda.ar/checkout'

export const PRECIO = '$8.990'
export const PRECIO_LARGO = 'ARS $8.990'

export const heroBullets: string[] = [
  'Método práctico',
  'Aplicable desde tu próxima compra',
  'Sin conocimientos financieros',
  'Acceso inmediato',
]

export type ProblemItem = {
  title: string
  text: string
}

export const problems: ProblemItem[] = [
  {
    title: 'Llegás a la caja y el total te sorprende',
    text: 'Compraste lo de siempre, pero el número final no cierra con lo que tenías en la cabeza.',
  },
  {
    title: 'La compra grande dura cada vez menos',
    text: 'Lo que antes te aguantaba todo el mes hoy se termina a mitad de la quincena.',
  },
  {
    title: 'Ves promociones por todos lados',
    text: 'Descuentos, cuotas, 2x1, reintegros… y no sabés cuál te conviene de verdad.',
  },
  {
    title: 'Tenés beneficios que no usás',
    text: 'Bancos y billeteras con descuentos que se te pasan por no tenerlos ordenados.',
  },
]

export type ShiftRow = {
  improvisada: string
  planificada: string
}

export const shiftRows: ShiftRow[] = [
  {
    improvisada: 'Comprás cuando se te termina',
    planificada: 'Comprás cuando conviene comprar',
  },
  {
    improvisada: 'Mirás sólo el precio de góndola',
    planificada: 'Calculás el precio final real',
  },
  {
    improvisada: 'Pagás con lo que tenés a mano',
    planificada: 'Elegís el medio de pago que más te devuelve',
  },
  {
    improvisada: 'Agarrás la promo porque parece barata',
    planificada: 'Comparás el precio por unidad',
  },
  {
    improvisada: 'Las promos se te vencen sin usarlas',
    planificada: 'Las tenés anotadas en tu rutina semanal',
  },
]

export const mechanismVars: { label: string; question: string }[] = [
  { label: 'Día', question: '¿Qué día conviene comprar esto?' },
  { label: 'Comercio', question: '¿Dónde está mejor hoy?' },
  { label: 'Precio', question: '¿Cuánto sale por unidad?' },
  { label: 'Promoción', question: '¿Cuál aplica de verdad?' },
  { label: 'Medio de pago', question: '¿Con cuál pago?' },
  { label: 'Reintegro', question: '¿Cuánto vuelve y cuándo?' },
]

export type Step = {
  number: string
  title: string
  text: string
  meta: string
}

export const steps: Step[] = [
  {
    number: '1',
    title: 'Planificá',
    meta: '15 minutos por semana',
    text: 'Revisás qué necesitás realmente esa semana y qué oportunidades hay disponibles en tus comercios, bancos y billeteras.',
  },
  {
    number: '2',
    title: 'Elegí',
    meta: 'Antes de salir de casa',
    text: 'Definís dónde comprar, qué día hacerlo y con qué medio de pago. Salís con las decisiones tomadas, no improvisando en la góndola.',
  },
  {
    number: '3',
    title: 'Recuperá',
    meta: 'Después de cada compra',
    text: 'Registrás los descuentos y reintegros que aplicaste y empezás a ver, en números, cuánto dejaste de pagar de más.',
  },
]

export type IncludedItem = {
  tag: string
  title: string
  description: string
  bullets?: string[]
}

export const included: IncludedItem[] = [
  {
    tag: 'Ebook principal',
    title: 'El Protocolo Anti-Inflación',
    description: 'El libro central del sistema: 75 a 85 páginas, en criollo y al grano.',
    bullets: [
      'Detectar oportunidades reales',
      'Comparar precios correctamente',
      'Aprovechar descuentos y reintegros',
      'Stockeo inteligente: qué sí y qué no',
      'Estrategias de góndola',
      'Errores que te hacen gastar de más',
    ],
  },
  {
    tag: 'Herramienta',
    title: 'Planificador de compra inteligente',
    description: 'Producto, precio, comercio, promo, medio de pago y reintegro: te queda a la vista el precio final real.',
  },
  {
    tag: 'Herramienta',
    title: 'Checklist antes de salir',
    description: 'Lista corta para revisar desde el celular en dos minutos.',
  },
  {
    tag: 'Herramienta',
    title: 'Calculadora de recupero',
    description: 'Registrás cuánta plata te volvió por descuentos y reintegros.',
  },
  {
    tag: 'Herramienta',
    title: 'Calendario semanal editable',
    description: 'Lo completás con las promos vigentes de tus bancos, billeteras y comercios.',
  },
]

export const forYou: string[] = [
  'Sentís que el supermercado se lleva cada vez más de tu sueldo.',
  'Usás tarjetas, bancos o billeteras pero no aprovechás sus beneficios.',
  'Querés ordenar tus compras sin convertirte en experto en finanzas.',
  'Tenés 15 minutos por semana para planificar.',
]

export const notForYou: string[] = [
  'No querés dedicarle ni unos minutos a organizar tus compras.',
  'Buscás una fórmula mágica para hacer dinero rápido.',
]

export type Faq = {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: '¿Qué pasa cuando cambian las promociones?',
    a: 'El protocolo no depende de una lista fija. Aprendés a analizar las promociones disponibles en cada momento, por eso el sistema sigue sirviendo aunque cambien.',
  },
  {
    q: '¿Necesito saber de economía?',
    a: 'No. No hay teoría, ni gráficos, ni términos raros. Es un método de organización para las compras de todos los días.',
  },
  {
    q: '¿Necesito tener todas las billeteras virtuales?',
    a: 'No. El sistema se adapta a los medios de pago y beneficios que ya tenés disponibles. Trabajás con lo tuyo.',
  },
  {
    q: '¿Sirve si compro en distintos supermercados?',
    a: 'Sí. Justamente de eso se trata: comparar las oportunidades de cada lugar y quedarte con el mejor precio final.',
  },
  {
    q: '¿Tengo que pasar horas buscando promociones?',
    a: 'No. La idea es armar una rutina semanal corta, de unos 15 minutos, que después te sale casi de memoria.',
  },
  {
    q: '¿Es solamente para el supermercado?',
    a: 'El foco principal es el consumo cotidiano, pero varios principios se aplican igual a otras compras del hogar.',
  },
  {
    q: '¿Lo recibo inmediatamente?',
    a: 'Sí. Es un producto digital: apenas confirmás la compra accedés al material completo.',
  },
]
